import { z } from "@core/zod";

import { BashCommandConditionSchema } from "./bash-command.ts";
import { FileConditionSchema } from "./file.ts";
import { ToolCallConditionSchema } from "./tool-call.ts";

export const TriggerConditionSchema = z.discriminatedUnion("kind", [
  BashCommandConditionSchema,
  FileConditionSchema,
  ToolCallConditionSchema,
]);
